import i18next from 'i18next';
import { __DEBUG__, DEFAULT_LANGUAGE } from '../constants';

import nl from './locales/nl.json';
import en from './locales/en.json';
import ar from './locales/ar.json';
import fa from './locales/fa.json';
import fr from './locales/fr.json';
import pr from './locales/pr.json';
import so from './locales/so.json';
import ti from './locales/ti.json';
import tr from './locales/tr.json';

i18next.init({
  fallbackLng: DEFAULT_LANGUAGE,
  fallbackNS: ['translation'],
  resources: {
    nl,
    en,
    ar,
    fa,
    fr,
    pr,
    so,
    ti,
    tr
  },
  parseMissingKeyHandler: (missing) => {
    if (__DEBUG__) {
      console.warn('MISSING TRANSLATION:', missing);
    }
    return missing;
  },
});

i18next.languages = ['nl', 'en', 'ar', 'fa', 'fr', 'pr', 'so', 'ti', 'tr'];

export default i18next;
